import { FC, ReactNode, createContext, useContext } from "react";
import {
  INicknameSettingsStorageState,
  LocalStorageStateSetter,
  useOutbidLocalStorageState,
} from "@axvdex/state/outbid/outbidPersist";

export type UserSettingContextState = {
  userSettings: INicknameSettingsStorageState;
  setUserSettings: LocalStorageStateSetter;
};
export const UserSettingContext = createContext<UserSettingContextState>({} as UserSettingContextState);
export function useUserSettings(): UserSettingContextState {
  return useContext(UserSettingContext);
}
export interface UserSettingsProviderProps {
  children: ReactNode;
}

export const UserSettingsProvider: FC<UserSettingsProviderProps> = ({ children }) => {
  const [outbidLocalStorageState, setOutbidLocalStorageState] = useOutbidLocalStorageState();
  return (
    <UserSettingContext.Provider
      value={{ userSettings: outbidLocalStorageState, setUserSettings: setOutbidLocalStorageState }}
    >
      {children}
    </UserSettingContext.Provider>
  );
};
